import { c as _c } from "react/compiler-runtime";
import { Container, classNames, FlexColumn, Media, Separator } from "@opensea/ui-kit";
import { headerViewCompactVariants } from "./constants";
import { headerViewOverflowClassNames } from "./variants";
export function HeroHeaderCompactLayout(t0) {
  const $ = _c(15);
  const {
    info,
    metadataChips,
    stats
  } = t0;
  let T0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      container,
      content
    } = headerViewCompactVariants();
    T0 = Container;
    t2 = container();
    t1 = content();
    $[0] = T0;
    $[1] = t1;
    $[2] = t2;
  } else {
    T0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== info) {
    t3 = <FlexColumn className="3xl:max-w-[40%] lg:max-w-[50%] lg:grow 2xl:max-w-[40%]">{info}</FlexColumn>;
    $[3] = info;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classNames("flex min-w-0 flex-col overflow-x-visible lg:flex-row lg:justify-end", headerViewOverflowClassNames);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== metadataChips) {
    t5 = <Media lessThan="md">{metadataChips}</Media>;
    $[6] = metadataChips;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Media lessThan="lg"><Separator className="my-4" /></Media>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== stats || $[10] !== t5) {
    t7 = <div className={t4}>{t5}{t6}{stats}</div>;
    $[9] = stats;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t7) {
    t8 = <T0 className={t2}><div className={t1}>{t3}{t7}</div></T0>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}